import type { SVGProps } from "react";
export interface Receipt02IconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Receipt02Icon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Receipt02IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="m5.125 20.25 1-.75a3.125 3.125 0 0 1 3.75 0l1.6 1.2a.88.88 0 0 0 1.05 0l1.6-1.2.213-.146a3.12 3.12 0 0 1 3.537.146l1 .749V3.125H5.125zm16 .25c0 1.696-1.876 2.687-3.267 1.793l-.133-.093-1.2-.9a.88.88 0 0 0-1.05 0l-1.6 1.2a3.13 3.13 0 0 1-3.75 0l-1.6-1.2a.875.875 0 0 0-1.05 0l-1.2.9c-1.401 1.05-3.4.05-3.4-1.7V3.125H2a1.125 1.125 0 0 1 0-2.25h20l.115.006a1.125 1.125 0 0 1 0 2.238L22 3.125h-.875z"
      />
      <path
        fill={color}
        d="M15.997 13.876a1.125 1.125 0 1 1 .005 2.25l-3.999.008a1.125 1.125 0 0 1-.005-2.25zm0-4.001a1.125 1.125 0 0 1 .005 2.25l-3.999.01-.115-.006a1.125 1.125 0 0 1 .11-2.244zm0-4a1.126 1.126 0 0 1 .005 2.25l-3.999.01-.115-.006a1.124 1.124 0 0 1 .11-2.244zm6.003-5a1.125 1.125 0 0 1 0 2.25H2a1.125 1.125 0 0 1 0-2.25zM9.375 15.005a1.376 1.376 0 0 1-2.743.14l-.007-.14.007-.14A1.376 1.376 0 0 1 8 13.628l.14.008c.694.07 1.235.656 1.235 1.368Zm0-4a1.376 1.376 0 0 1-2.743.14l-.007-.14.007-.141A1.375 1.375 0 0 1 8 9.63l.14.008c.694.07 1.235.655 1.235 1.366Zm0-4a1.375 1.375 0 0 1-2.743.141l-.007-.14.007-.141A1.375 1.375 0 0 1 8 5.63l.14.007c.694.07 1.235.656 1.235 1.368"
      />
    </svg>
  );
}
